export class HandleRefreshHistoryItems {}
